"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const CommonRootWeb_1 = require("./CommonRootWeb");
// Did it this way
// but could just do
// interface TextInputProps { miniIcon:string;}
// to extends react props
const TGTextFieldRootWeb = props => {
    const { readOnly, warning, computed, translateFunction = text => text } = props, moreProps = __rest(props, ["readOnly", "warning", "computed", "translateFunction"]);
    const classes = (0, CommonRootWeb_1.useStyles)();
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip, calculated: computed, error: props.error, translateFunction: translateFunction }),
        react_1.default.createElement(core_1.TextField, { fullWidth: true, InputLabelProps: {
                shrink: true,
                className: (0, clsx_1.default)(classes.labelShrink, warning && classes.warningText),
            }, className: (0, clsx_1.default)(classes.formElementWrapper, classes.customBorderColor), variant: "outlined", error: props.error, value: props.value, onChange: props.onChange, onClick: props.onClick, onFocus: props.onFocus, placeholder: translateFunction(props.placeholder), InputProps: {
                readOnly,
                disabled: readOnly,
                className: (0, clsx_1.default)(warning && classes.warningBorderBottom),
            }, FormHelperTextProps: { className: (0, clsx_1.default)(warning && classes.warningText) }, required: false, 
            // We want the Tooltip to be triggered on field hovering, but positionned relative to the label
            onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) }),
        !!props.helperText && (react_1.default.createElement(core_1.FormHelperText, { className: (0, clsx_1.default)(warning && classes.warningText, classes.errorText) }, translateFunction(props.helperText)))));
};
exports.default = TGTextFieldRootWeb;
//# sourceMappingURL=TGTextFieldRootWeb.js.map